import React, { useRef, useEffect, useState } from "react";
import {
  MDBContainer,
  MDBRow,
  MDBCol,
  MDBCard,
  MDBCardBody,
  MDBCardTitle,
  MDBCardText,
  MDBBtn,
  MDBIcon,
  MDBTable,
  MDBTableHead,
  MDBTableBody,
} from "mdb-react-ui-kit";

import { useLocation, useNavigate } from "react-router-dom";
import Table from "../Table";
import DataTable from "../DataTable";
import voucherDateAndTimeFormatter from "../../utilities/voucherDateAndTimeFormatter";
import axios from "axios";
import Loader from "../Loader";
import API_BASE_URL from "../../utilities/apiConfig";
import { useSelector } from "react-redux";
import FeesDetailsTable from "./FeesDetailsTable";
import axiosInstance from "../../utilities/apiConfig";

const FeesDetails = () => {
  const [loading, setLoading] = useState(false);
  const [membershipFeesDetails, setMembershipFeesDetails] = useState([]);

  const userDetails = useSelector((state) => state.auth?.userData?.authUser);
  const { userId } = userDetails;

  const handleGetFeesDetails = async () => {
    try {
      setLoading(true);
      const response = await axiosInstance.get(
        `/LoginFees/get_fees_details_by_userid/${userId}`
      );

      console.log("fees details data of advocates by user id", response.data);
      if (response.data.response.statusCode === 200) {
        setMembershipFeesDetails(response.data?.advocateFeesDetails);
      } else {
        setMembershipFeesDetails([]);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const formatRegData = voucherDateAndTimeFormatter(membershipFeesDetails, [
    "entryDate",
    "registrationDate",
    "requestedTimePreiodDate",
    "appliedDate",
    "dateOfBirth",
    "mentorJoiningDate",
    "retirementYear",
  ]);

  const handleClick = (event, cellValues) => {
    console.log("button executed", cellValues);
  };

  const membershipTableColumns = [
    {
      field: "advocateBarId",
      headerName: "Registration No",
      minWidth: 150,
      flex: 1,
      align: "left",
      headerAlign: "left",
    },
    // { field: 'membershipTypeId', headerName: 'Membership Type ID', minWidth: 150, flex: 1, align: 'left', headerAlign: 'left' },
    {
      field: "memberType",
      headerName: "Member Type",
      minWidth: 150,
      flex: 1,
      align: "left",
      headerAlign: "left",
    },
    {
      field: "feesAmount",
      headerName: "Fees Amount",
      minWidth: 150,
      flex: 1,
      align: "left",
      headerAlign: "left",
    },
    {
      field: "entryDate",
      headerName: "Entry Date",
      minWidth: 150,
      flex: 1,
      align: "left",
      headerAlign: "left",
    },
    {
      field: "bookNo",
      headerName: "Book No",
      minWidth: 100,
      flex: 1,
      align: "left",
      headerAlign: "left",
    },
    {
      field: "srNo",
      headerName: "Serial No",
      minWidth: 100,
      flex: 1,
      align: "left",
      headerAlign: "left",
    },
    // { field: 'userId', headerName: 'User ID', minWidth: 200, flex: 1, align: 'left', headerAlign: 'left' },
    // { field: 'barAssociationCode', headerName: 'Bar Association Code', minWidth: 150, flex: 1, align: 'left', headerAlign: 'left' },
  ];

  useState(() => {
    handleGetFeesDetails();
  }, []);
  return (
    <>
      {loading && <Loader />}
      <MDBContainer fluid>
        <FeesDetailsTable
          tableName="Fees Details Data "
          feesDetailsData={membershipFeesDetails}
          TableColumns={membershipTableColumns}
          height={750}
        />
      </MDBContainer>
    </>
  );
};

export default FeesDetails;
